var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import "../../components/header";
import "../../components/leftMenu";
import KnockoutModel from "../../lib/knockout_model";
import "../../components/paging";
import * as ajax from "../../app-lib/ajax_proxy";
import './OpponentAnalysis.css';
import * as Configs from "../../app-lib/constants";
import "../../components/paging";
var OpponentAnalysis = /** @class */ (function (_super) {
    __extends(OpponentAnalysis, _super);
    function OpponentAnalysis(root) {
        var _this = _super.call(this, "/api/competitor", root, { dateType: 0, pageIndex: 1, type: 0, content: '' }) || this;
        _this.KeyWord = ko.observable(''); //搜索字段
        _this.mserachType = ko.observableArray([{ text: '公司名称', val: 1 }, { text: '公司概述', val: 2 }, { text: '合作模式', val: 3 }, { text: '编制人员', val: 4 }]); //竞争对手搜索下拉
        _this.marketTypeVal = ko.observable(); //类型值
        _this.choose_index = ko.observableArray(); //选中的用户
        return _this;
    }
    // 删除一条数据
    OpponentAnalysis.prototype.deleteOneData = function (r) {
        var _this = this;
        // console.log('确认删除',r)
        window.popBox.show('是否删除该条数据', { isConfirmModal: true, showFooter: true }).then(function (d) {
            console.log('确认删除');
            ajax.deleteIt('/api/competitor/' + r.id).then(function (d) {
                if (d.status == '0')
                    window.popBox.show('删除成功');
                _this.loadData();
            });
        });
    };
    // 搜索
    OpponentAnalysis.prototype.searchList = function () {
        this.data.pageIndex = 1;
        this.data.type = this.marketTypeVal();
        this.data.content = this.KeyWord();
        this.loadData();
    };
    // 时间正序排列
    OpponentAnalysis.prototype.areast = function () {
        this.data.dateType = 1;
        this.loadData();
    };
    // 时间倒序排列
    OpponentAnalysis.prototype.areain = function () {
        this.data.dateType = 0;
        this.loadData();
    };
    OpponentAnalysis.prototype.ExportChose = function (res, index) {
        if (this.choose_index.indexOf(index) == -1) {
            this.choose_index.push(index);
        }
        else {
            this.choose_index.remove(index);
        }
        return true;
    };
    // ie设置
    OpponentAnalysis.prototype.ieS = function () {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion == 7) {
                return true;
            }
            else if (fIEVersion == 8) {
                return true;
            }
            else if (fIEVersion == 9) {
                return true;
            }
            else if (fIEVersion == 10) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    //用户管理全选
    OpponentAnalysis.prototype.btn_choose_all = function (event) {
        var vm = this.viewModel();
        // debugger;
        if (this.ieS()) {
            if (event.srcElement.checked) {
                for (var i in vm.data.list) {
                    if (this.choose_index.indexOf(vm.data.list[i].id < 1)) {
                        this.choose_index.push(vm.data.list[i].id);
                    }
                }
            }
            else {
                this.choose_index.removeAll();
            }
        }
        else {
            if (event.target.checked) {
                // this.choose_index.removeAll();
                for (var i in vm.data.list) {
                    if (this.choose_index.indexOf(vm.data.list[i].id < 1)) {
                        this.choose_index.push(vm.data.list[i].id);
                    }
                }
            }
            else {
                this.choose_index.removeAll();
            }
        }
        return true;
    };
    // 导出excel
    OpponentAnalysis.prototype.exportExcel = function () {
        if (this.choose_index().length < 1) {
            return window.popBox.show('至少选择一条数据');
        }
        console.log(this.choose_index());
        var str = '';
        for (var i = 0; i < this.choose_index().length; i++) {
            if (i < 1) {
                str = this.choose_index()[0];
            }
            else {
                str = str + ',' + this.choose_index()[i];
            }
        }
        window.open(Configs.Configs.serviceUrl + '/api/competitor/export?id=' + str);
    };
    return OpponentAnalysis;
}(KnockoutModel));
var DemoModel = /** @class */ (function (_super) {
    __extends(DemoModel, _super);
    function DemoModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DemoModel.prototype.init = function () {
        this.vm = new OpponentAnalysis(this.container.querySelector('.OpponentAnalysis'));
        console.log("eeeeeeeee");
        this.vm.bind();
    };
    DemoModel.prototype.update = function (arg) {
        this.vm.choose_index([]);
        this.vm.data.pageIndex = 1;
        this.vm.data.content = '';
        this.vm.KeyWord('');
        this.vm.loadData();
        return Promise.resolve();
    };
    DemoModel.prototype.onInitComplete = function () {
    };
    return DemoModel;
}(Page));
export default DemoModel;
